import settings from "../settings";
import axios from 'axios';
import { APP_VERSION } from '../version';

class SystemService {
    static sharedApi = null;

    checkSystemCommunication() {
        return new Promise((resolve, reject) => {
            axios.get(settings.url + 'online', {
                headers: {
                    'x-app-version': String(APP_VERSION)
                }
            }).then((r) => {
                this.checkForceReloadHeaders(r.headers);
                if (r.data.online === true) {
                    resolve(true);
                } else {
                    reject('Ο server δεν είναι προσβάσιμος. Επιβεβαιώστε ότι η συσκευή σας είναι συνδεδεμένη στο δίκτυο και στο VPN της Nordia');
                }
            }).catch(e => {
                if (e.response && e.response.headers) {
                    this.checkForceReloadHeaders(e.response.headers);
                }
                reject('Ο server δεν είναι προσβάσιμος. Επιβεβαιώστε ότι η συσκευή σας είναι συνδεδεμένη στο δίκτυο και στο VPN της Nordia');
            });
        });
    }

    checkForceReloadHeaders(headers) {
        if (!headers) return;
        const serverVersionHeader = headers['x-app-version'] || headers['X-App-Version'];

        if (serverVersionHeader && parseInt(serverVersionHeader, 10) > APP_VERSION) {
            const serverVer = parseInt(serverVersionHeader, 10);
            console.log(`[SystemService] Backend signaled newer client version (${serverVer} > ${APP_VERSION})`);
            import('./VersionService').then((m) => m.default.notifyUpdateAvailable(serverVer));
        }
    }

    getApiAccess() {
        if (SystemService.sharedApi) {
            return SystemService.sharedApi;
        }

        const instance = axios.create({
            baseURL: settings.url
        });

        // Request interceptor: attach version
        instance.interceptors.request.use((config) => {
            config.headers = config.headers || {};
            config.headers['x-app-version'] = String(APP_VERSION);
            return config;
        });

        // Response interceptor: check force reload header
        instance.interceptors.response.use(
            (response) => {
                this.checkForceReloadHeaders(response.headers);
                return response;
            },
            (error) => {
                if (error && error.response && error.response.headers) {
                    this.checkForceReloadHeaders(error.response.headers);
                }
                return Promise.reject(error);
            }
        );

        SystemService.sharedApi = instance;
        return instance;
    }

    getBaseUrl() {
        return settings.url;
    }
}

export { SystemService };
